export const manualUrlList: {
	[key: string]: { [key: string]: { title: string; link: string } }
} = {
	KDM6: {
		en: {
			title: 'English',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem6/kedem+6+User+Manual+(English).pdf',
		},
		ko: {
			title: 'Korean',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem6/kedem+6+User+Manual+(Korean).pdf',
		},
		de: {
			title: 'German',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem6/kedem+6+User+Manual+(German).pdf',
		},
		es: {
			title: 'Spanish',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem6/kedem+6+User+Manual+(Spanish).pdf',
		},
		ja: {
			title: 'Japanese',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem6/kedem+6+User+Manual+(Japanese).pdf',
		},
	},
	KDM4: {
		en: {
			title: 'English',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem4/kedem+4+User+Manual+(English).pdf',
		},
		ko: {
			title: 'Korean',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem4/kedem+4+User+Manual+(Korean).pdf',
		},
		de: {
			title: 'German',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem4/kedem+4+User+Manual+(German).pdf',
		},
		es: {
			title: 'Spanish',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem4/kedem+4+User+Manual+(Spanish).pdf',
		},
		ja: {
			title: 'Japanese',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/kedem4/kedem+4+User+Manual+(Japanese).pdf',
		},
	},
	// 2026-09-15 v0.6 — kedem8 세션 빌드본. 순서 = EN · KO · 나머지 언어 코드순(Kedem 과 같은 규칙)
	PLS8: {
		en: {
			title: 'English',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/koinospls8/Koinos+PLS+8+User+Manual+(English).pdf',
		},
		ko: {
			title: 'Korean',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/koinospls8/Koinos+PLS+8+User+Manual+(Korean).pdf',
		},
		de: {
			title: 'German',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/koinospls8/Koinos+PLS+8+User+Manual+(German).pdf',
		},
		es: {
			title: 'Spanish',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/koinospls8/Koinos+PLS+8+User+Manual+(Spanish).pdf',
		},
		fr: {
			title: 'French',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/koinospls8/Koinos+PLS+8+User+Manual+(French).pdf',
		},
		it: {
			title: 'Italian',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/koinospls8/Koinos+PLS+8+User+Manual+(Italian).pdf',
		},
		ja: {
			title: 'Japanese',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/koinospls8/Koinos+PLS+8+User+Manual+(Japanese).pdf',
		},
		nl: {
			title: 'Dutch',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/koinospls8/Koinos+PLS+8+User+Manual+(Dutch).pdf',
		},
		pt: {
			title: 'Portuguese',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/koinospls8/Koinos+PLS+8+User+Manual+(Portuguese).pdf',
		},
		zh: {
			title: 'Chinese',
			link: 'https://judahs-public.s3.ap-northeast-2.amazonaws.com/manual/koinospls8/Koinos+PLS+8+User+Manual+(Chinese).pdf',
		},
	},
}

/* ------------------------------------------------------------------ */
/* Monolith Manuals (2026-09-08) — `/manuals` 한 장. 제품별 하위 페이지·내장 뷰어는 두지 않는다. */
/* PDF 주소의 SSOT 는 위 `manualUrlList` 그대로다 — 여기서는 그 값을 꺼내 쓴다.              */
/* ------------------------------------------------------------------ */

export type ManualLanguageCode =
	| 'en'
	| 'ko'
	| 'de'
	| 'es'
	| 'fr'
	| 'it'
	| 'ja'
	| 'nl'
	| 'pt'
	| 'zh'

export interface ManualLanguageType {
	code: ManualLanguageCode
	/** 영어 표기 (English · Korean …) */
	label: string
	/** 그 언어 표기 (한국어 · Deutsch …) */
	native: string
	url: string
	/** 다운로드 파일명 */
	fileName: string
}

export interface ManualProductType {
	/** 소문자 제품 코드 (`kdm6`). `manualUrlList` 키는 대문자 */
	code: string
	name: string
	/** `season` = 아직 발행 전. 조용히 한 줄로 내려앉는다 */
	status: 'published' | 'season'
	languages: ManualLanguageType[]
	/** 웹판(`/manuals/{code}/{lang}`)이 있으면 true. 언어 목록은 PDF 와 같다 */
	web: boolean
}

const nativeObj: { [code in ManualLanguageCode]: string } = {
	en: 'English',
	ko: '한국어',
	de: 'Deutsch',
	es: 'Español',
	fr: 'Français',
	it: 'Italiano',
	ja: '日本語',
	nl: 'Nederlands',
	pt: 'Português',
	zh: '简体中文',
}

/** 알파벳순보다 앞에 고정할 언어. 배열 순서가 곧 화면 순서 */
const PINNED_LANGUAGES: ManualLanguageCode[] = ['en', 'ko']

const pinnedRank = (code: ManualLanguageCode): number => {
	const index = PINNED_LANGUAGES.indexOf(code)
	return index === -1 ? PINNED_LANGUAGES.length : index
}

const languagesOf = (key: string, name: string): ManualLanguageType[] =>
	Object.keys(manualUrlList[key] ?? {})
		.map(aCode => ({
			code: aCode as ManualLanguageCode,
			label: manualUrlList[key][aCode].title,
			native: nativeObj[aCode as ManualLanguageCode] ?? manualUrlList[key][aCode].title,
			url: manualUrlList[key][aCode].link,
			fileName: `${name} User Manual (${manualUrlList[key][aCode].title}).pdf`,
		}))
		// 화면 순서 = English · Korean 을 맨 위에, 나머지는 영어 표기 알파벳순(2026-09-15 로컬 시안).
		// 위 `manualUrlList` 의 키 순서는 화면에 쓰지 않는다.
		.sort(
			(a, b) =>
				pinnedRank(a.code) - pinnedRank(b.code) || a.label.localeCompare(b.label, 'en'),
		)

export const manualList: ManualProductType[] = [
	// 2026-09-18 화면 순서 = Koinos PLS 8 · Kedem 6 · Kedem 4. 배열 순서가 곧 화면 순서
	{
		code: 'pls8',
		name: 'Koinos PLS 8',
		status: 'published',
		languages: languagesOf('PLS8', 'Koinos PLS 8'),
		web: true,
	},
	{
		code: 'kdm6',
		name: 'Kedem 6',
		status: 'published',
		languages: languagesOf('KDM6', 'Kedem 6'),
		web: false,
	},
	{
		code: 'kdm4',
		name: 'Kedem 4',
		status: 'published',
		languages: languagesOf('KDM4', 'Kedem 4'),
		web: false,
	},
]

/* ------------------------------------------------------------------ */
/* 웹 매뉴얼 (2026-10-28) — `/manuals/{code}/{lang}` 언어당 한 장.                       */
/* 본문은 빌드 때 S3 에서 받아 온 정적 JSON(`scripts/sync-manuals.js`).                    */
/* 기획 SSOT = claudeFiles/judahsWeb/MANUAL_WEB_PLAN.md                                     */
/* ------------------------------------------------------------------ */

/** 사이트에서 웹 매뉴얼 데이터가 놓이는 곳 (`public/manual-web/`) */
export const MANUAL_WEB_BASE = '/manual-web'

export const manualWebPath = (code: string, lang: string): string =>
	`/manuals/${code}/${lang}`

export const manualWebList: ManualProductType[] = manualList.filter(
	aManual => aManual.web,
)

/** 리더의 언어 드롭다운에서 마지막으로 고른 언어 (2026-10-28 사용자 요청). 제품 공통 한 값 */
const MANUAL_LANGUAGE_KEY = 'judahs_manual_language'

/** 드롭다운에서 고를 때만 저장한다 — 공유 링크로 들어온 언어는 "고른" 게 아니라서 남기지 않는다 */
export const saveManualLanguage = (code: ManualLanguageCode) => {
	try {
		window.localStorage.setItem(MANUAL_LANGUAGE_KEY, code)
	} catch {
		// 사파리 사생활 보호 모드 등 저장소가 막혀 있으면 기억만 못 한다
	}
}

const readManualLanguage = (): string | null => {
	try {
		return window.localStorage.getItem(MANUAL_LANGUAGE_KEY)
	} catch {
		return null
	}
}

/**
 * 처음 열 언어. ① 마지막으로 고른 언어(이 제품에 그 판이 있을 때) ② 브라우저 언어 목록에서 가진 언어판
 * ③ English. `zh-TW` 처럼 지역이 붙은 값은 앞 두 글자로 본다.
 */
export const pickManualLanguage = (aManual: ManualProductType): ManualLanguageCode => {
	const codeList = aManual.languages.map(aLang => aLang.code)
	const saved = readManualLanguage()
	if (saved !== null && codeList.includes(saved as ManualLanguageCode)) {
		return saved as ManualLanguageCode
	}
	const preferList = typeof navigator === 'undefined' ? [] : navigator.languages ?? []
	const found = preferList
		.map(aTag => aTag.slice(0, 2).toLowerCase())
		.find(aCode => codeList.includes(aCode as ManualLanguageCode))
	return (found as ManualLanguageCode | undefined) ?? 'en'
}

/** `build_web.py` 가 굽는 manual.json 의 절 하나 */
export interface ManualSectionType {
	/** 앵커. 번호가 있으면 `s9.4.3` · `sA`, Part 는 `part-i`, 번호 없는 장은 `x1` — 10개 언어가 같다 */
	id: string
	/** `9.4.3` · `A` · `Part I` · 빈 문자열 */
	num: string
	title: string
	/** 1 = Part · 2 = 장 · 3 = 절 · 4 = 하위 절 */
	level: 1 | 2 | 3 | 4
	kind: 'part' | 'chapter' | 'appendix' | 'section'
	html: string
	/** 검색용 평문 */
	text: string
}

export interface ManualDocumentType {
	product: string
	lang: ManualLanguageCode
	version: string
	/** PDF 표지·상호참조와 같은 현지화 라벨 */
	labels: { title: string; chapter: string; chapterAfter: boolean; appendix: string }
	built: string
	sections: ManualSectionType[]
}
